// Shared by the Sales Credit Note and Debit Note pages: the "Invoice Ref. No."
// list.

/** How many Approved invoices of the customer the list loads. */
export const INVOICE_OPTIONS_PAGE_SIZE = 5000;

const sameText = (a, b) => (a || "").trim().toLowerCase() === (b || "").trim().toLowerCase();

/**
 * The customer's invoices out of a customer search (which also matches
 * similar names, e.g. "Customer AB" for "Customer A"). Any of the customer's
 * invoices can be credited or debited, whoever its contact person is; the
 * ones for the note's contact person come first.
 */
export function customerInvoices(invoices, customerName, contactPerson) {
    const mine = (invoices || []).filter((inv) => sameText(inv.customer, customerName));
    const forContact = mine.filter((inv) => contactPerson && sameText(inv.contactPerson, contactPerson));
    return [...forContact, ...mine.filter((inv) => !forContact.includes(inv))];
}

/**
 * Invoice numbers for the dropdown. A note being edited keeps showing its own
 * invoice even when that invoice is no longer in the list.
 */
export function invoiceOptions(invoices, currentInvoiceId) {
    const ids = (invoices || []).map((inv) => inv.id).filter(Boolean);
    return currentInvoiceId && !ids.includes(currentInvoiceId) ? [currentInvoiceId, ...ids] : ids;
}
